module.exports = __webpack_public_path__ + "glyphicons-regular.64610dbdf459573b251d.woff";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.pro/glyphicons-regular.woff
// module id = ../../../../../src/assets/css/fonts/glyphicons.pro/glyphicons-regular.woff
// module chunks = 2